import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { forkJoin, of } from 'rxjs';
import { BrandNatoCageCode } from 'src/app/enums/BrandNatoCageCode.enum';


@Injectable({
  providedIn: 'root'
})
export class ImpulsesService {

  baseUrl = environment.baseUrl
  xApiKey = environment.xApiKey

  constructor(private tokenService: TokenService, private httpClient: HttpClient) { }

  getImpulses(pageNo: number, pageSize: number, purchaserCode: string, partNumber: string, mrCode: string) {
    const headers = {
      'x-api-key': this.xApiKey,
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    };
    return this.httpClient.get(this.baseUrl + `/requisitions/D40/2536269/350676/0/20`, { headers });
  }

  getMockUsers(): any {
    return this.httpClient.get('https://run.mocky.io/v3/ecd98bf9-dfb3-48dd-90fa-9d0892780609');
  }

  getDocumentOrderData(partNos: string) {
  return this.httpClient.get(this.baseUrl + `/get_document_order?partNos=${encodeURIComponent(partNos)}`);
}
  getUrlForFetchingImpulses(pageNo: number, pageSize: number, purchaserCode: string, partNumber: string, partDescription: string, mrCode: string, packageId: string, state: string, type: string, userId: string, sortOrder: any, sortColumn: any) {
    if ((partNumber != '') && (purchaserCode == '' && mrCode == '' && partDescription == '' && packageId == '' && state == '' && type == '')) {
      const partNoApi = this.httpClient.get(this.baseUrl + `/requisition_partnumber?partNumber=${partNumber}&userId=${userId}&pageNo=${pageNo}&pageSize=${pageSize}&sortDirection=${sortOrder}&sortColumn=${sortColumn}&orderType=''`)
      const partNoCount = this.httpClient.get(this.baseUrl + `/requisition_partnumber_count?partNumber=${partNumber}&userId=${userId}&orderType=''`)
      return forkJoin([partNoApi, partNoCount]);
    } else if ((mrCode != '') && (purchaserCode == '' && partDescription == '' && partNumber == '' && packageId == '' && state == '' && type == '')) {
      const mrCodeApi = this.httpClient.get(this.baseUrl + `/requisition_mrcode?mrCode=${mrCode}&userId=${userId}&pageSize=${pageSize}&pageNo=${pageNo}&sortDirection=${sortOrder}&sortColumn=${sortColumn}&orderType=''`)
      const mrCodeCount = this.httpClient.get(this.baseUrl + `/requisition_mrcode_count?mrCode=${mrCode}&userId=${userId}&orderType=''`)
      return forkJoin([mrCodeApi, mrCodeCount]);
    } else if ((purchaserCode != '') && (mrCode == '' && partNumber == '' && partDescription == '' && packageId == '' && state == '' && type == '')) {
      const purchaserCodeApi = this.httpClient.get(this.baseUrl + `/requisition_purchaser?purchaserCode=${purchaserCode}&userId=${userId}&pageSize=${pageSize}&pageNo=${pageNo}&sortDirection=${sortOrder}&sortColumn=${sortColumn}&orderType=''`)
      const purchaserCodeCount = this.httpClient.get(this.baseUrl + `/requisition_purchaser_count?purchaserCode=${purchaserCode}&userId=${userId}&orderType=''`)
      return forkJoin([purchaserCodeApi, purchaserCodeCount]);
    } else if ((packageId != '') && (mrCode == '' && partNumber == '' && partDescription == '' && purchaserCode == '' && state == '' && type == '')) {
      const packageIdApi = this.httpClient.get(this.baseUrl + `/requisition_packageid?packageId=${packageId}&pageSize=${pageSize}&pageNo=${pageNo}&userId=${userId}&sortDirection=${sortOrder}&sortColumn=${sortColumn}&orderType=''`)
      const packageIdCount = this.httpClient.get(this.baseUrl + `/requisition_packageid_count?packageId=${packageId}&userId=${userId}&orderType=''`)
      return forkJoin([packageIdApi, packageIdCount])
    }
    // } else if ((state != '') && (mrCode == '' && partNumber == '' && purchaserCode == '' && packageId == '')) {
    //   const packageIdApi = this.httpClient.get(this.baseUrl + `/requisition_reqstate?reqStateCode=${state}&pageSize=${pageSize}&pageNo=${pageNo}&userId=${userId}`)
    //   const packageIdCount = this.httpClient.get(this.baseUrl + `/requisition_reqstate_count?reqStateCode=${state}&userId=${userId}`)
    //   return forkJoin([packageIdApi, packageIdCount])
    // } 
    // else if ((type != '') && (mrCode == '' && partNumber == '' && purchaserCode == '' && packageId == '' && state == '')) {
    //   const packageIdApi = this.httpClient.get(this.baseUrl + `/requisition_reqstate?reqStateCode=${state}&pageSize=${pageSize}&pageNo=${pageNo}&userId=${userId}`)
    //   const packageIdCount = this.httpClient.get(this.baseUrl + `/requisition_reqstate_count?reqStateCode=${state}&userId=${userId}`)
    //   return forkJoin([packageIdApi, packageIdCount])
    // }
    else if (partDescription !== '' &&  purchaserCode === '' && partNumber === '' && mrCode === '' && packageId === '' && state === '' && type === ''){
      const partDescriptionApi = this.httpClient.get(this.baseUrl + `/requisition_partdescription?partDescription=${encodeURIComponent(partDescription)}&userId=${userId}&pageNo=${pageNo}&pageSize=${pageSize}&sortDirection=${sortOrder}&sortColumn=${sortColumn}`)
      const partDescriptionCount = this.httpClient.get(this.baseUrl + `/requisition_partdescriptionr_count-pm-dev?partDescription=${encodeURIComponent(partDescription)}&userId=${userId}&orderType=''`)
      return forkJoin([partDescriptionApi,partDescriptionCount])
    }
    else if (state != '' || packageId != '' || mrCode != '' || purchaserCode != '' || partNumber != '' || partDescription != '' || type == '') {
      const requisitions = this.httpClient.get(this.baseUrl + `/get_requisitions?purchaserCode=${purchaserCode}&packageId=${packageId}&partDescription=${encodeURIComponent(partDescription)}&mrCode=${mrCode}&partNumber=${partNumber}&reqStateCode=${state}&requisitionType=${type}&pageNo=${pageNo}&pageSize=${pageSize}&userId=${userId}&sortDirection=${sortOrder}&sortColumn=${sortColumn}`);
      const requisitionsCount = this.httpClient.get(this.baseUrl + `/get_requisitions_pagination?purchaserCode=${purchaserCode}&mrCode=${mrCode}&partNumber=${partNumber}&packageId=${packageId}&partDescription=${encodeURIComponent(partDescription)}&reqStateCode=${state}&requisitionType=${type}&userId=${userId}`);
      return forkJoin([requisitions, requisitionsCount])
    }
    else {
      return of([{}, {}])
    }
  }

  getImpulsesForExcel(purchaserCode: string, partNumber: string, partDescription:string, mrCode: string, packageId: string, state: string, type: string, userId: string, paramType: string) {
    return this.httpClient.get(this.baseUrl + `/generate-excel-py?purchaserCode=${purchaserCode}&userId=${userId}&paramType=${paramType}&partNumber=${partNumber}&partDescription=${encodeURIComponent(partDescription)}&mrCode=${mrCode}&packageId=${packageId}&state=${state}&type=${type}`)
  }

  getPartNoByBrand(partNumber: any, selectedPartNoOption: any) {
    return this.httpClient.get(this.baseUrl + `/requisition_by_brandpartno?partNumber=${partNumber}&partNoOption=${selectedPartNoOption}`)
  }

 // In your Angular service
getRequisitions(purchaserCode: any, packageId: any, mrCode: any, partNumber: any, pageNo: any, pageSize: any, userId: any, userOrg: any) {
  return this.httpClient.get(this.baseUrl + 
    `/get_requisitions?purchaserCode=${purchaserCode}&packageId=${packageId}&mrCode=${mrCode}&partNumber=${partNumber}&pageNo=${pageNo}&pageSize=${pageSize}&userId=${userId}&userOrg=${userOrg || ''}`)
}
  getRequisitionsPagination(purchaserCode: any, mrCode: any, partNumber: any, packageId: any, userId: any) {
    return this.httpClient.get(this.baseUrl + `/get_requisitions_pagination?purchaserCode=${purchaserCode}&mrCode=${mrCode}&partNumber=${partNumber}&packageId=${packageId}&userId=${userId}`)
  }

  getManPartNo(partNo: any) {
    return this.httpClient.get(this.baseUrl + `/get_brand_part_number?partNumber=${partNo}`)
  }

  sendEmailDocumentOrder(body: any) {
    return this.httpClient.post(this.baseUrl + '/send-email-document-order', body);
  }
  getBrandPartNoMapping(uniquePartNos: string[], responses: any[], rows: any[]): any[] {
    const partNoToMANPartNoMap: { [key: string]: string } = {};
    const partNoToNavistarPartNoMap: { [key: string]: string } = {};
    uniquePartNos.forEach((partNo, index) => {
      const item = responses[index];
      let NavistarbrandpartNo = '';
      let MANbrandpartNo = '';
      if (item && item.partners) {
        let MANpartner;
        let NavistarPartner
        //if(orderType == 'EXN'){
        NavistarPartner = item.partners.find((p: any) => p.brand === BrandNatoCageCode.NAVISTAR);
        //}else{
        MANpartner = item.partners.find((p: any) => p.brand === BrandNatoCageCode.MAN);
        //}
        if (NavistarPartner) {
          NavistarbrandpartNo = NavistarPartner.objectId ? NavistarPartner.objectId : '';
        }
        if (MANpartner) {
          MANbrandpartNo = MANpartner.objectId ? MANpartner.objectId : '';
        }
      }
      partNoToMANPartNoMap[partNo] = MANbrandpartNo;
      partNoToNavistarPartNoMap[partNo] = NavistarbrandpartNo;
    });
    return rows.map(row => ({
      ...row,
      NavistarPartNo: partNoToNavistarPartNoMap[row.PARTNO] || '',
      MANPartNo: partNoToMANPartNoMap[row.PARTNO] || ''
    }));
  }

  getBrandPartNoMappingForOrders(uniquePartNos: string[], responses: any[], rows: any[], orderType: string): any[] {
    const partNoToBrandPartNoMap: { [key: string]: string } = {};
    uniquePartNos.forEach((partNo, index) => {
      const item = responses[index];
      let brandpartNo = '';
      if (item && item.partners) {
        let partner;
        if (orderType == 'EXN') {
          partner = item.partners.find((p: any) => p.brand === BrandNatoCageCode.NAVISTAR);
        } else {
          partner = item.partners.find((p: any) => p.brand === BrandNatoCageCode.MAN);
        }
        if (partner) {
          brandpartNo = partner.objectId ? partner.objectId : '';
        }
      }
      partNoToBrandPartNoMap[partNo] = brandpartNo;
    });
    return rows.map(row => ({
      ...row,
      BrandPartNo: partNoToBrandPartNoMap[row.PARTNO] || ''
    }));
  }

  getFeatureFlag() {
    return this.httpClient.get(this.baseUrl + `/get_feature_flags`)
  }

  getPartPriceHistory(partNo: any, userId: any) {
    return this.httpClient.get(this.baseUrl + `/get_partprice_history?partNo=${partNo}&userId=${userId}`)
  }

  getSupplierName(pageNo: any, pageSize: any, userId: any, supplierName: any, supplierNo: any) {
    const headers = {
      'x-api-key': this.xApiKey
    };
    return this.httpClient.get(this.baseUrl + `/suppliers?pageNo=${pageNo}&pageSize=${pageSize}&userId=${userId}&supplierName=${supplierName}&supplierNo=${supplierNo}`, { headers });
  }

   removePartFromPackage(partNumber: string, productionLocation: string, emailAddress : string){
    return this.httpClient.post(this.baseUrl + `/remove_part_from_package`,{
      partNumber : partNumber, productionLocCode : productionLocation, emailAddress : emailAddress
    });
  }

}

